import { gql } from '@apollo/client'

export const PREPARE_PAYMENT = gql`
  mutation PreparePayment($input: PreparePaymentInput!) {
    preparePayment(input: $input) {
      paymentNumber
    }
  }
`
